/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BigCommerceProductRef
 */
export interface BigCommerceProductRef {
  /**
   *
   * @type {number}
   * @memberof BigCommerceProductRef
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof BigCommerceProductRef
   */
  name: string;
}

/**
 * Check if a given object implements the BigCommerceProductRef interface.
 */
export function instanceOfBigCommerceProductRef(
  value: object,
): value is BigCommerceProductRef {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function BigCommerceProductRefFromJSON(
  json: any,
): BigCommerceProductRef {
  return BigCommerceProductRefFromJSONTyped(json, false);
}

export function BigCommerceProductRefFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommerceProductRef {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function BigCommerceProductRefToJSON(json: any): BigCommerceProductRef {
  return BigCommerceProductRefToJSONTyped(json, false);
}

export function BigCommerceProductRefToJSONTyped(
  value?: BigCommerceProductRef | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
  };
}
